/**
 * User roles enum - defines all available user roles in the system
 */
export enum UserRoles {
  BALTIC = 'BALTIC',
  CARGO_COUNT = 'CARGO_COUNT',
  FIXED_DAYS = 'FIXED_DAYS',
  FIXTURES = 'FIXTURES',
  RECENT_FIXTURES = 'RECENT_FIXTURES',
  USER_GROUPS = 'USER_GROUPS',
  USERS = 'USERS',
  REPORTS = 'REPORTS',
  DAILY_REPORT = 'DAILY_REPORT',
  MONTHLY_REPORTS = 'MONTHLY_REPORTS',
  ANNUAL_REPORTS = 'ANNUAL_REPORTS',
  REPORTS_FILES = 'REPORTS_FILES',
  POSITION_LIST = 'POSITION_LIST',
  CARGO_LIST = 'CARGO_LIST',
  BUNKER_PRICES = 'BUNKER_PRICES',
  POWERBI_BASIC = 'POWERBI_BASIC',
  POWERBI_PRIVILEGED = 'POWERBI_PRIVILEGED',
  POWERBI_PRIVILEGED_KPC = 'POWERBI_PRIVILEGED_KPC',
  COMPANIES = 'COMPANIES',
}

/**
 * UserGroup interface - represents a user group entity
 */
export interface UserGroup {
  id: number;
  name: string;
  description: string;
  code: string;
  isActive: boolean;
  sort: number;
  roleCodes: UserRoles[];
  updateByUser: string;
  updatedAt: string;
  requiredRoleCodes: UserRoles[];
}

/**
 * GroupRole interface - represents a role that can be assigned to a group
 */
export interface GroupRole {
  roleId: number;
  roleName: string;
  roleCode: UserRoles;
  sort?: number;
}

/**
 * UserGroupRole interface - represents a role assignment within a user group
 */
export interface UserGroupRole {
  userGroupId: number;
  name: string;
  roleCode: UserRoles;
  description?: string;
  isActive?: boolean;
  allowedStartDate: Date | string | null;
  allowedEndDate: Date | string | null;
  updatedAt: Date | string;
  roleDescription?: string;
  [name: string]: unknown;
}

/**
 * User role ordering structure for UI display
 */
export interface UserRoleOrderItem {
  label?: string;
  roleCode: UserRoles[];
}

/**
 * API request/response types
 */
export interface CreateUserGroupRequest {
  name: string;
  code: string;
  description?: string;
  isActive: boolean;
}

export interface UpdateUserGroupRequest extends Partial<CreateUserGroupRequest> {}

export interface SortUserGroupsRequest {
  userGroupIds: number[];
}

export interface SortRolesRequest {
  roleIds: number[];
}

export interface UpdateGroupRoleStatusRequest {
  roleCode: string;
  isActive: boolean;
}

export interface UpdateGroupRolesRequest {
  roleCode: string;
  isActive?: boolean;
  allowedStartDate?: string | null;
  allowedEndDate?: string | null;
  description?: string;
}
